module.exports = __webpack_public_path__ + "img/chest.4b38a2d5.png";